module.exports = __webpack_public_path__ + "static/img/一种二维码插杆灌溉装置.41a699f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/一种二维码插杆灌溉装置.jpg
// module id = VzH0
// module chunks = 15